import { Typography } from 'components';
import './index.scss';

const Oferta = () => {
  return (
    <div className='oferta'>
      <Typography variant='h1' bold>
        ПУБЛІЧНА ОФЕРТА
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Дана Публічна оферта, далі - "Оферта", є офіційною публічною
          пропозицією щодо придбання інформаційно-консультаційних послуг "ФОП
          Броварний Всеволод Віталійович" та залучених на умовах даної Оферти
          третіх осіб (далі - "Компанія"), адресованою необмеженому колу осіб,
          розміщеною на Інтернет-сайті за адресою:
          https://main.d1wdeqzlr1fr6a.amplifyapp.com, далі - "Сайт".
        </Typography>
      </div>
      <Typography variant='h2'>1. ВИЗНАЧЕННЯ, НАВЕДЕНІ В ОФЕРТІ</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          1.1 Учасник та/або Учасники (у всіх відмінках) - це користувач
          (потенційний користувач) послуг Компанії на умовах цієї Оферти, який
          надав свої персональні дані, та є дієздатною фізичною особою, яка
          досягла 18 років, має законне право вступати в договірні відносини з
          Компанією. Компанія не здійснює перевірку дієздатності та не несе
          відповідальності за дії Учасника, які порушують вимоги чинного
          законодавства.
        </Typography>
        <Typography variant='body'>
          1.2 Послуги - це Вебінари, Тренінги та/або Коучинг, які надаються
          Компанією на умовах цієї Оферти.
        </Typography>
        <Typography variant='body'>
          1.3 Вебінар - онлайн відео-урок, онлайн-лекція, онлайн-майстер-клас
          або онлайн-курс (два і більше Вебінарів), що проводяться в режимі
          реального часу та/або в режимі трансляції їхнього запису за допомогою
          web-технологій, що виражаються у формі передавання інформації шляхом
          демонстрації оригінальних методів опанування певного змісту шляхом
          надання Учасникам Персонального посилання на умовах цієї Оферти.
        </Typography>
        <Typography variant='body'>
          1.4 Посилання на сайт - буквено-цифровий код або інший код, що
          дозволяє отримати доступ до Сайту Компанії в мережі Інтернет.
        </Typography>
        <Typography variant='body'>
          1.5 Персональне посилання - персональний буквено-цифровий код або
          інший код, що дозволяє Учаснику отримати доступ до Вебінару.
        </Typography>

        <Typography variant='body'>
          1.6 Тренінг - це урок, лекція, майстер-клас, інтенсив-курс або
          довготривалий курс, марафон, що проводяться в режимі реального часу та
          виражаються у формі передавання інформації шляхом демонстрації
          оригінальних методів освоєння певного змісту за активної ролі
          Учасників на умовах цієї Оферти.
        </Typography>

        <Typography variant='body'>
          1.7 Коучинг - це Тренінг, який проводиться з Учасником в
          індивідуальній формі на умовах цієї Оферти.
        </Typography>

        <Typography variant='body'>
          {' '}
          1.8 Пакет учасника - це умовне позначення обсягу послуг в рамках
          однієї Послуги, який впливає на її вартість. В рамках однієї послуги
          Учасники можуть вибрати будь-який з Пакетів учасника на Сайті або на
          умовах цієї Оферти.
        </Typography>

        <Typography variant='body'>
          1.9 Реєстрація Учасника (далі - Реєстрація в усіх формах) - це надання
          персональних даних Учасником шляхом заповнення форми на Сайті та/або
          перехід за посиланням на Сайт з подальшим наданням персональних даних
          та/або надання персональних даних за телефоном Компанії та/або в інший
          спосіб на умовах цієї Оферти.
        </Typography>

        <Typography variant='body'>
          1.10 Анкета - це паперовий або електронний документ, який при
          заповненні, підписанні та передачі Компанії надає Учаснику Тренінгу
          та/або Коучингу право на отримання Послуг Компанії на умовах цієї
          Оферти.
        </Typography>
      </div>
      <Typography variant='h2'>2. ПРАВИЛА УЧАСТІ У ВЕБІНАРІ</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          {' '}
          2.1 Для участі у Вебінарі Учаснику необхідно зареєструватися, і
          виконати всі умови даної Оферти.
        </Typography>

        <Typography variant='body'>
          2.2 Після реєстрації на Вебінар, на зазначену Учасником електронну
          пошту, надалі "e-mail", перед початком трансляції Вебінару, надійде
          повідомлення про можливість участі у Вебінарі, яке містить Персональне
          посилання, яке є дійсним лише для одного Учасника, яким його було
          отримано, перейшовши по ньому, Учасник підтверджує факт ознайомлення з
          умовами даної Оферти, в результаті чого йому надається доступ до
          сторінки трансляції Вебінару. У разі надання персонального посилання
          на запис Вебінару, на Учасника поширюються всі без винятку умови цієї
          Оферти.
        </Typography>

        <Typography variant='body'>
          2.3 Для участі у Вебінарі Учасники самостійно забезпечують дотримання
          належних технічних умов для персонального комп'ютера або іншого
          мобільного пристрою.
        </Typography>

        <Typography variant='body'>
          2.4 Компанія не несе відповідальності за неможливість участі Учасника
          у Вебінарі, що виникла з причин, які не залежать від Компанії, зокрема
          через невиконання Учасником, у тому числі, але не виключно п. 2.3,
          цієї Оферти.
        </Typography>

        <Typography variant='body'>
          2.5 Компанія має право на власний розсуд визначати дату, час і тему
          Вебінару, лекторів, тривалість Вебінару, змінювати (переносити) і
          скасовувати їх, повідомивши Учасника на зазначений при реєстрації
          контактний e-mail.
        </Typography>

        <Typography variant='body'>
          2.6 У разі, якщо Компанія прийняла рішення про перенесення дати та/або
          часу Вебінару, Учасники, які замовили відповідний Вебінар, отримують
          повідомлення про нову дату та/або час, а також Персональне посилання
          для участі в такому Вебінарі на вказаний Учасником під час реєстрації
          контактний e- mail.
        </Typography>

        <Typography variant='body'>
          2.7 Компанія має право не допустити до участі у Вебінарі Учасників,
          які порушили або не виконали умови цієї Оферти.
        </Typography>
        <Typography variant='body'>
          2.8 Компанія залишає за собою право надавати Учасникам Вебінару
          посилання на запис проведеного Вебінару (за його наявності) та/або
          додаткові матеріали, здійснювати післявебінарну підтримку на умовах
          Пакету Учасника.
        </Typography>

        <Typography variant='body'>
          2.9 У разі пропуску Учасником Вебінару, в тому числі з причин, не
          залежних від Компанії, Учасник не має права вимагати його повторного
          проведення або надання інформації, що міститься у Вебінарі, в іншій
          формі. При цьому послуги Компанії вважаються наданими належним чином.
          Компанія залишає за собою право надати такому Учаснику Персональне
          посилання на запис проведеного Вебінару (за його наявності) та/або
          додаткові матеріали.
        </Typography>

        <Typography variant='body'>
          2.10 За порушення морально-етичних норм та/або поширення інформації
          рекламного чи іншого характеру, іншу некоректну поведінку Учасника, що
          заважає проведенню Вебінару, Компанія вправі на власний розсуд
          припинити надання доступу такому Учаснику до написання повідомлень під
          час Вебінару.
        </Typography>

        <Typography variant='body'>
          2.11 Під час проведення Вебінару Учасники мають право, за наявності
          технічних можливостей, ставити запитання, що стосуються виключно теми
          та змісту Вебінару, якщо особа, яка проводить його, не повідомить про
          інший порядок постановки запитань і відповідей на них. Обмеження
          можуть встановлюватися Компанією щодо всього Вебінару або певного часу
          його проведення.
        </Typography>

        <Typography variant='body'>
          2.12 По закінченню Вебінару Учасники, які виконали всі умови цієї
          Оферти, в тому числі, але не виключно, умови п. 2.2. цієї Оферти, на
          розсуд Компанії отримують Сертифікати Компанії про участь у такому
          Вебінарі.
        </Typography>
        <Typography variant='body'>
          2.13 За порушення морально-етичних норм та/або поширення інформації
          рекламного чи іншого характеру, іншу некоректну поведінку Учасника,
          Компанія має право в односторонньому порядку розірвати відносини з
          Учасником та повернути кошти за запитом.
        </Typography>
      </div>
      <Typography variant='h2'>3. ПРАВИЛА УЧАСТІ У ТРЕНІНГУ</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          3.1 Для участі в Тренінгу Учаснику необхідно Зареєструватися і
          виконати всі умови даної Оферти.
        </Typography>

        <Typography variant='body'>
          3.2 Заповнення Анкети перед Тренінгом і передача її Компанії є однією
          з обов'язкових умов допуску Учасника до участі в Тренінгу.
        </Typography>

        <Typography variant='body'>
          3.3 Компанія не несе відповідальності за неможливість участі Учасника
          в Тренінгу, яка виникла з причин, що не залежать від Компанії.
        </Typography>

        <Typography variant='body'>
          3.4 Компанія має право на власний розсуд визначати дату, час, місце,
          тему Тренінгу, лекторів, тривалість Тренінгу, змінювати (переносити)
          та скасовувати його, повідомивши Учасника за вказаним при Реєстрації
          контактним e-mail.
        </Typography>

        <Typography variant='body'>
          3.5 У разі, якщо Компанія прийняла рішення про перенесення дати, часу
          та/або місця Тренінгу, Учасники отримують повідомлення про такі зміни.
        </Typography>

        <Typography variant='body'>
          3.6 Компанія має право не допускати до участі в Тренінгу Учасника,
          який порушив та/або не виконав умови цієї Оферти.
        </Typography>

        <Typography variant='body'>
          3.7 У разі пропуску Учасником Тренінгу без попередження Компанії,
          згідно з п. 6.1.4. Оферти, зокрема з причин, не залежних від Компанії,
          Учасник не має права вимагати його повторного проведення або надання
          інформації, що міститься в Тренінгу, в іншій формі. При цьому послуги
          Компанії вважаються наданими належним чином. Компанія залишає за собою
          право надати такому Учаснику Персональне посилання на запис
          проведеного Тренінгу (за його наявності) та/або додаткові матеріали.
          На свій розсуд Компанія має право запропонувати такому Учаснику участь
          в аналогічному наступному Тренінгу або замінити вид послуги на умовах
          цієї Оферти.
        </Typography>

        <Typography variant='body'>
          3.8 За порушення морально-етичних норм та/або поширення інформації
          рекламного чи іншого характеру, іншої некоректної поведінки Учасника,
          що заважає проведенню Тренінгу, Компанія має право на власний розсуд
          припинити надання послуг такому Учаснику. При цьому вартість Тренінгу,
          в ході якого надання послуг було припинено, Учаснику не
          відшкодовується.
        </Typography>

        <Typography variant='body'>
          3.9 Під час проведення Тренінгу, Учасники мають право ставити
          запитання, що стосуються виключно теми та змісту Тренінгу, якщо особа,
          що проводить його, не повідомить про інший порядок постановки запитань
          та відповідей на них. Такі обмеження можуть встановлюватися Компанією
          до всього Тренінгу або його частини.
        </Typography>

        <Typography variant='body'>
          3.10 Компанія залишає за собою право надавати Учасникам Тренінгу
          Персональні посилання на запис проведеного Тренінгу (за їх наявності)
          та/або додаткові матеріали, здійснювати післятренінгову підтримку на
          умовах пакета Учасника.
        </Typography>

        <Typography variant='body'>
          3.11 По закінченню Тренінгу Учасники, які виконали всі умови цієї
          Оферти, в тому числі, але не виключно, умови п. 3.2. цієї Оферти, на
          розсуд Компанії отримують Сертифікати Компанії про участь у Тренінгу.
        </Typography>
      </div>
      <Typography variant='h2'>4. ПРАВИЛА УЧАСТІ В КОУЧИНГУ</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          4.1 Для участі в Коучингу Учаснику необхідно зареєструватися і
          виконати всі умови даної Оферти.
        </Typography>

        <Typography variant='body'>
          4.2 Заповнення Анкети перед Коучингом і передача її Компанії є однією
          з обов'язкових умов допуску Учасника до участі в Коучингу.
        </Typography>

        <Typography variant='body'>
          4.3 Компанія не несе відповідальності за неможливість участі Учасника
          в Коучингу, яка виникла з причин, що не залежать від Компанії.
        </Typography>

        <Typography variant='body'>
          4.4 Компанія має право на власний розсуд визначати місце, тему
          Коучингу, його тривалість, лекторів, змінювати (переносити) та
          скасовувати його, повідомивши Учасника про це.
        </Typography>
        <Typography variant='body'>
          4.5 Компанія погоджує з Учасником дату і час Коучингу, а також
          можливість їх перенесення за умови попередження Учасником про
          неможливість бути присутнім в узгоджену з Компанією дату і час.
        </Typography>

        <Typography variant='body'>
          4.6 У разі систематичного пропуску (два і більше разів) Коучингу без
          попереднього (не пізніше ніж за 12 годин) повідомлення Учасником про
          неможливість бути присутнім в узгоджену з Компанією дату і час, з
          причин, що не залежать від Компанії. Компанія залишає за собою право
          надати такому Учаснику додаткові матеріали (за наявності) та на
          власний розсуд запропонувати замінити вид послуги на умовах цієї
          Оферти. При цьому послуги Компанії вважаються наданими належним чином.
        </Typography>

        <Typography variant='body'>
          4.7 Компанія має право не допускати до участі в Коучингу Учасника,
          який порушив та/або не виконав умови цієї Оферти.
        </Typography>

        <Typography variant='body'>
          4.8 У разі порушення морально-етичних норм та/або іншої некоректної
          поведінки Учасника Коучингу, Компанія має право на власний розсуд
          припинити надання послуг такому Учаснику. При цьому вартість Коучингу,
          в ході якого надання Послуги було припинено, Учаснику не
          відшкодовується.
        </Typography>
      </div>
      <Typography variant='h2'>5. ПРАВА ТА ОБОВ'ЯЗКИ КОМПАНІЇ</Typography>
      <div className='policy-block'>
        <Typography variant='body'>5.1 Компанія має право:</Typography>

        <Typography variant='body'>
          5.1.1. відмовити Учаснику в наданні Послуг на умовах цієї Оферти.
        </Typography>

        <Typography variant='body'>
          5.1.2 Проводити фото- та відеофіксацію під час надання Послуг, а також
          використовувати отримані під час фото- та відеофіксації матеріали на
          власний розсуд.
        </Typography>

        <Typography variant='body'>
          5.1.3 Розробляти на власний розсуд Пакети учасника, тему, програми та
          тривалість Послуги, визначати її дату, час, місце, змінювати
          (переносити) та скасовувати, визначати кількість та склад лекторів,
          які виступають під час надання Послуги.
        </Typography>

        <Typography variant='body'>
          5.1.4 На підставі отриманого від Учасника контактного e-mail
          здійснювати масову розсилку інформаційних повідомлень без згоди
          Учасника та/або осіб, які залишили свої дані на сайті Компанії. При
          цьому в таких інформаційних повідомленнях розміщується посилання на
          відмову від їх отримання.
        </Typography>

        <Typography variant='body'>
          5.1.5 Залучати до надання Послуги, або її окремих частин, третіх осіб.
        </Typography>

        <Typography variant='body'>
          5.1.6 В односторонньому порядку вносити зміни в умови цієї Оферти,
          зокрема, але не виключно, змінювати правила оплати за надання Послуг,
          вносити зміни в порядок надання Послуг, шляхом розміщення нової
          редакції Оферти на Сайті.
        </Typography>

        <Typography variant='body'>5.2 Обов'язки Компанії:</Typography>

        <Typography variant='body'>
          5.2.1 Надавати Послуги на умовах цієї Оферти
        </Typography>

        <Typography variant='body'>
          5.2.2 Зберігати інформацію та відомості (в тому числі персональні
          дані) надані Учасником на виконання умов цієї Оферти в межах чинного
          законодавства у сфері захисту персональних даних.
        </Typography>

        <Typography variant='body'>
          5.2.3 Здійснювати консультаційну підтримку Учасників щодо послуг
          Компанії та умов їх отримання на умовах даної Оферти.
        </Typography>

        <Typography variant='body'>
          5.2.4 У повному обсязі повернути грошові кошти Учаснику виключно в
          разі повного скасування Компанією оплаченої Учасником Послуги.
        </Typography>
      </div>
      <Typography variant='h2'>
        6. ПРАВА ТА ОБОВ'ЯЗКИ УЧАСНИКА. ЗАБОРОНИ ДЛЯ УЧАСНИКА
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>6.1 Учасник має право:</Typography>
        <Typography variant='body'>
          6.1.1 Звертатися до Компанії для отримання інформації про Послуги
          Компанії, умови їх надання та умови цієї Оферти за номерами телефонів,
          вказаними на Сайті та/або через форми зворотного зв'язку, та/або
          поштовим або іншим повідомленням з 9.00 до 18.00 (за київським часом),
          окрім суботи, неділі та святкових днів, відповідно до графіку роботи
          Компанії.
        </Typography>
        <Typography variant='body'>
          6.1.2 Отримувати будь-яку із запропонованих Послуг Компанії на умовах
          цієї Оферти.
        </Typography>
        <Typography variant='body'>
          6.1.3 Відмовитися від отримання Послуги до моменту її оплати.
        </Typography>
        <Typography variant='body'>
          6.1.4 На умовах Оферти перенести отримання повністю оплаченої послуги
          на наступну найближчу встановлену Компанією дату її надання або
          узгодити з Компанією можливість заміни Послуги за умови попередження
          Компанії за один робочий день про неможливість отримання Послуги. Таке
          перенесення може бути тільки один раз (крім Коучингу).
        </Typography>
        <Typography variant='body'> 6.2 Обов'язки Учасника:</Typography>
        <Typography variant='body'>
          6.2.1 До акцептування Оферти ознайомитися з її чинними умовами.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.2.2 Виконувати умови цієї Оферти.
        </Typography>
        <Typography variant='body'>
          6.2.3 Забезпечити своєчасну явку для отримання Послуги.
        </Typography>
        <Typography variant='body'>
          6.3 Учаснику заборонено, якщо не передбачено конкретною Послугою або
          Пакетом учасника:
        </Typography>
        <Typography variant='body'>
          6.3.1 Поширювати відео-, аудіозапис Послуги будь-яким способом.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.2 Поширювати матеріали Послуги у вигляді розшифровки, тобто
          перекладу аудіо-, відеоматеріалів у текстовий формат, та/або перекладу
          іншими мовами.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.3 У комерційних цілях використовувати отриману від Компанії
          інформацію шляхом перекладу або поширення знань та основ без
          попереднього узгодження з Компанією.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.4 Використовувати отриману від Компанії інформацію, включно (без
          обмеження) з метою створення подібної та/або конкурентної послуги чи
          сервісу, або з метою отримання комерційної чи фінансової вигоди без
          попереднього погодження з Компанією.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.5 Організовувати та проводити власні заходи або заняття на базі
          Послуг Компанії.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.6 Здійснювати дії, спрямовані на порушення умов цієї Оферти.
          Здійснювати дії, спрямовані на порушення умов цієї Оферти.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.7 Передавати та/або надавати доступ до Вебінару будь-яким третім
          особам за винятком умов цієї Оферти.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.8 Допускати поширення недостовірної, неправдивої інформації,
          інформації, яка ганьбить честь, гідність, ділову репутацію Компанії,
          лекторів та інших осіб, а також інформації, яка спонукає і закликає до
          міжнаціональної, етнічної нетерпимості, ворожнечі, війни, зміни
          державного устрою країн, інформації, поширення якої заборонене чинним
          законодавством України і нормами Міжнародного права в залежності від
          території надання Послуг.
        </Typography>
        <Typography variant='body'>
          {' '}
          6.3.9 Здійснювати інші дії, не передбачені Офертою, але такі, що
          містять склад кримінального або адміністративного правопорушення, або
          порушують права та законні інтереси Компанії, інших Учасників та/або
          третіх осіб.
        </Typography>
      </div>
      <Typography variant='h2'>
        7. ВАРТІСТЬ ПОСЛУГ ТА ПОРЯДОК РОЗРАХУНКІВ
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          7.1 Вартість послуг Компанії за Пакетами Учасників (за наявності
          Пакетів Учасників) розміщується на Сайті та може змінюватися залежно
          від наближення дати надання Послуги. Інформація про актуальну ціну
          Послуги розміщується на Сайті.
        </Typography>
        <Typography variant='body'>
          7.2 Оплата здійснюється шляхом перерахування грошових коштів на
          поточний рахунок Компанії.
        </Typography>

        <Typography variant='body'>
          7.3 Послуга надається Компанією після повної, 100 (сто) % її оплати
          Учасником. Така оплата означає ознайомлення і повну згоду Учасника з
          усіма умовами Оферти.
        </Typography>

        <Typography variant='body'>
          7.4 Учасник має право оплачувати вартість Послуг частинами, при цьому
          за Учасником фіксується вартість Послуги, яка діяла на момент
          здійснення оплати першої частини.
        </Typography>

        <Typography variant='body'>
          7.5 Моментом оплати вважається зарахування грошових коштів на поточний
          рахунок Компанії відповідно до обраного Учасником способу оплати.
        </Typography>

        <Typography variant='body'>
          7.6 На умовах Оферти, у разі зміни виду Послуги на послугу, що є
          дорожчою за первісну, Учасник доплачує різницю вартості такої Послуги,
          а у випадку, якщо сума нової Послуги є дешевшою за первинну, різниця
          вартості таких послуг стає авансом на наступну Послугу. За погодженням
          з Компанією різниця вартості таких послуг може бути повернута
          Учаснику.
        </Typography>

        <Typography variant='body'>
          7.7 На умовах, які будуть оголошені під час надання Послуги, Компанія
          може запропонувати акційну ціну (ціну зі знижкою та обмеженим терміном
          дії пропозиції) на придбання наступної Послуги.
        </Typography>

        <Typography variant='body'>
          7.8 Перенесення Послуги на умовах цієї Оферти є безкоштовним.
        </Typography>

        <Typography variant='body'>
          7.9 Компанія передбачає можливість продажу Подарункових сертифікатів
          на отримання Послуги, на їх користувачів поширюються всі без винятку
          умови цієї Оферти як на Учасників.
        </Typography>

        <Typography variant='body'>
          7.10 Учасники мають можливість отримати індивідуальні бонуси,
          привілеї, знижки від Компанії на її особистий розсуд.
        </Typography>

        <Typography variant='body'>
          7.11 Компанія може проводити безкоштовні Вебінари та Тренінги для
          Учасників. На такі безкоштовні Вебінари та Тренінги поширюються всі
          умови цієї Оферти.
        </Typography>
      </div>
      <Typography variant='h2'>
        8. ВІДПОВІДАЛЬНІСТЬ КОМПАНІЇ ТА УЧАСНИКА. ВИРІШЕННЯ СПОРІВ
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          8.1 Компанія не дає Учаснику жодних гарантій щодо послуг, що
          надаються, включно з (але не обмежуючись): безперебійністю,
          своєчасністю, безпекою, безпомилковістю, точною відповідністю до
          вирішення конкретних завдань і умов Учасника.
        </Typography>

        <Typography variant='body'>
          8.2 Учасник самостійно несе повну відповідальність за наслідки
          будь-якого роду, зокрема, але не виключно, за очікувані результати від
          отриманої Послуги, що можуть настати в результаті надання послуг
          Компанією.
        </Typography>

        <Typography variant='body'>
          8.3 У разі надання Учасником завідомо неправдивих даних, згідно з п.
          9.2.3 Оферти, Компанія відмовляється від будь-якої відповідальності,
          претензії таких Учасників не розглядаються.
        </Typography>

        <Typography variant='body'>
          8.4 У разі порушень у роботі мережі Інтернет, обладнання, програмного
          забезпечення Учасника, Компанія не несе відповідальності за
          неможливість надання Послуги.
        </Typography>

        <Typography variant='body'>
          8.5 Компанія не несе відповідальності за будь-які збитки, завдані
          Учаснику, в тому числі, але не виключно, в результаті дій або
          бездіяльності, надання недостовірних відомостей (інформації) іншими
          Учасниками.
        </Typography>

        <Typography variant='body'>
          8.6 Сумарна відповідальність Компанії за будь-якими позовами та/або
          претензіями (в тому числі, але не виключно, за невиконання умов
          Оферти) не може перевищувати суму платежу, сплаченого Учасником за
          Послугу Компанії.
        </Typography>

        <Typography variant='body'>
          8.7 Компанія не є навчальним закладом і не займається будь-якою
          освітньою (педагогічною) діяльністю. Сертифікати, що видаються
          Учасникам за результатами отриманих Послуг не є документами, що
          підтверджують: (1) кваліфікацію, (2) рівень знань, (3) набуття фахових
          знань, (4) навичок, умінь тощо, а лише підтверджують факт отримання
          Послуг від Компанії.
        </Typography>

        <Typography variant='body'>
          8.8 Учасник, акцептуючи дану Оферту, приймає на себе також ризики
          неотримання прибутку та ризики можливих збитків, пов'язаних з
          використанням інформації, отриманої Учасником при наданні Послуг
          Компанією.
        </Typography>
        <Typography variant='body'>
          8.9 Компанія не несе відповідальності за отримання результату,
          отримання результату, що не відповідає очікуванням Учасника, оскільки
          успішність використання Учасником отриманої інформації залежить від
          багатьох невідомих Компанії чинників: цілеспрямованості,
          працьовитості, наполегливості, рівня інтелектуального розвитку,
          творчих здібностей Учасника, інших його індивідуальних якостей і
          персональних характеристик.
        </Typography>

        <Typography variant='body'>
          8.10 Компанія не несе відповідальності за невідповідність змісту
          Послуги очікуванням Учасника. Зміст Послуги представляє приватні думки
          лекторів, які можуть не збігатися з думкою Компанії або Учасника.
        </Typography>

        <Typography variant='body'>
          8.11 За жодних умов та обставин Компанія не несе відповідальності
          перед третіми особами за використання посилань та інформації,
          отриманої Учасником під час Послуги та переданої ним, а також за
          прийняті рішення та/або Учасниками та/або будь-якими третіми особами
          на підставі інформації, отриманої Учасниками під час надання Послуги
          Компанією.
        </Typography>

        <Typography variant='body'>
          8.12 За жодних обставин Компанія не несе відповідальності перед
          Учасником та/або перед будь-якою третьою особою за будь-які прямі
          та/або непрямі збитки, спричинені внаслідок будь-якого використання
          інформації з Сайту або на будь-якому іншому сайті, на який є
          гіперпосилання з Сайту, які виникли у зв'язку з доступом,
          використанням чи неможливістю використання Сайту, інформації,
          отриманої від Компанії під час надання будь-якої Послуги, виникнення
          залежності, зниження продуктивності, звільнення чи переривання
          трудової діяльності, а також за будь-які інші обставини.
        </Typography>

        <Typography variant='body'>
          8.13 Компанія не несе відповідальність за невиконання або неналежне
          виконання своїх зобов'язань за цією Офертою, якщо це невиконання або
          неналежне виконання зумовлені дією обставин непереборної сили
          (форс-мажорних обставин). У разі настання для Компанії форс-мажорних
          обставин, вона не пізніше 10 (десяти) календарних днів з дати їх
          настання повідомляє на Сайті.
        </Typography>

        <Typography variant='body'>
          8.14 Всі суперечки, що виникають за цією Офертою або пов'язані з нею,
          вирішуються шляхом переговорів між Компанією та Учасником.
        </Typography>

        <Typography variant='body'>
          8.15 Якщо відповідний спір неможливо вирішити шляхом переговорів, він
          вирішується судом відповідно до чинного процесуального законодавства
          України.
        </Typography>
      </div>
      <Typography variant='h2'>9. ІНШІ УМОВИ</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          9.1 Конфіденційною визнається вся ділова інформація між Компанією та
          Учасником, в тому числі, але не виключно, інформація про Компанію,
          Учасників, третіх осіб, технології.
        </Typography>

        <Typography variant='body'>
          9.2 в рамках виконання умов Закону України "Про захист персональних
          даних" Учасникам повідомляється:
        </Typography>

        <Typography variant='body'>
          9.2.1 Власником і розпорядником персональних даних Учасників є
          Компанія.
        </Typography>

        <Typography variant='body'>
          9.2.2 Персональні дані Учасників обробляються з метою надання послуг,
          маркетингових відносин, рекламних відносин, податкових відносин та
          відносин у сфері бухгалтерського обліку.
        </Typography>

        <Typography variant='body'>
          9.2.3 З метою обробки персональних даних, яка зазначена в п. 9.2.2.
          цієї Оферти, можуть оброблятися ім'я, прізвище, по батькові, паспортні
          дані, контактний номер телефону, адреса електронної пошти,
          реєстраційний номер облікової картки платника податків, рід занять,
          професія, анкетні дані, адреса реєстрації.
        </Typography>

        <Typography variant='body'>
          9.2.4 З персональними даними будуть вчинятися такі дії: збирання,
          накопичення, зберігання, адаптування, зміна, поновлення, використання
          та поширення (розповсюдження, реалізація, передача), знеособлення,
          знищення персональних даних.
        </Typography>

        <Typography variant='body'>
          9.2.5 Персональні дані Учасників без отримання від них окремої згоди
          та/або їхнього повідомлення можуть бути передані третім особам для
          здійснення мети, зазначеної в п. 9.2.2. цієї Оферти. Крім того,
          передача третім особам персональних даних Учасників без згоди суб'єкта
          персональних даних або уповноваженої ним особи допускається у
          випадках, визначених Законом України "Про захист персональних даних",
          і тільки (якщо це необхідно) в інтересах національної безпеки,
          економічного добробуту та прав людини.
        </Typography>

        <Typography variant='body'>
          9.2.6 Персональні дані Учасників будуть оброблятися з моменту їхнього
          отримання та протягом усієї діяльності Компанії, після чого вони
          будуть знищені Компанією у зв'язку із закінченням строку зберігання
          персональних даних. Персональні дані Учасників зберігатимуться
          протягом строку, передбаченого законодавством України для виконання
          мети, зазначеної в п. 9.2.2. цієї Оферти, після чого вони будуть
          знищені у зв'язку із закінченням строку зберігання персональних даних.
        </Typography>

        <Typography variant='body'>
          9.2.7 Учасники можуть відкликати згоду на обробку своїх персональних
          даних письмово направивши Компанії запит, але при цьому втрачають
          право на отримання Послуги.
        </Typography>

        <Typography variant='body'>
          9.2.8 Учасники володіють усіма правами, передбаченими статтею 8 Закону
          України "Про захист персональних даних".
        </Typography>
        <Typography variant='body'>
          9.2.9 Отримуючи Послуги, кожен Учасник дає згоду Компанії на обробку
          його персональних даних в обсязі та на умовах, зазначених у п.9.2.3
          цієї Оферти.
        </Typography>

        <Typography variant='body'>
          9.3 Учасники мають право на отримання Послуги тільки в разі, якщо ними
          були дотримані всі вимоги цієї Оферти.
        </Typography>

        <Typography variant='body'>
          9.4 Інформування Учасників здійснюється в порядку, передбаченому п.
          5.2.3. цієї Оферти.
        </Typography>

        <Typography variant='body'>
          9.5 У разі виникнення ситуації, яка допускає неоднозначне тлумачення
          цієї Оферти та/або питань, не врегульованих нею, остаточне рішення
          приймається Компанією відповідно до вимог чинного законодавства
          України. При цьому рішення Компанії є остаточним і не підлягає
          оскарженню.
        </Typography>

        <Typography variant='body'>
          9.6 У разі відмови Учасника від отримання ним Послуги, будь-які
          претензії Учасника з цього приводу не приймаються і не розглядаються
          Компанією.
        </Typography>

        <Typography variant='body'>
          9.7 Учасник отримує Послуги відповідно до умов цієї Оферти тільки
          після виконання всіх обов'язкових умов допуску Учасника до отримання
          Послуги.
        </Typography>

        <Typography variant='body'>
          9.8 Проїзд до місця отримання Послуги та у зворотному напрямку,
          проживання, харчування та витрати, пов'язані з отриманням Послуги та
          будь-які інші витрати Учасника оплачуються самим Учасником.
        </Typography>

        <Typography variant='body'>
          9.9 Оферта затверджена Компанією і діє протягом тривалості надання
          Послуг.
        </Typography>
      </div>
    </div>
  );
};

export default Oferta;
